'use client';
import React from 'react';
import Sidebar from '@/components/Sidebar';
import { twMerge } from 'tailwind-merge';
import BangKienNghi from './components/BangKienNghi';

export default function KienNghiCuTriPage(props) {
  const { rightBanners, linkPages, websiteCode, slugDetail } = props;
  return (
    <div className="flex flex-col min-h-screen">
      <div className={twMerge('container mx-auto bg-white', slugDetail ? 'px-2 md:px-4 py-2' : '')}>
        <div className="flex flex-col lg:flex-row gap-6">
          <section className="lg:w-3/4 ">
            <BangKienNghi {...props} />
          </section>
          <aside className="w-full lg:w-1/4">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </aside>
        </div>
      </div>
    </div>
  );
}
